/* eslint-disable @typescript-eslint/no-unused-vars */
/* for mobx decorators? */
import { inject, observer } from 'mobx-react';
import React, { Fragment } from 'react';

import ChatStore, { IChatMessage } from '../../../stores/ChatStore';
import {
  AgentChatBubble,
  ChatMessageWarningIcon,
  CustomerChatBubble,
  FlexContainer,
  ReadReceipt,
  ResendStyled,
  UndeliveredNotice,
} from '../styled';

interface IChatMessageProps {
  item: IChatMessage;
}

export interface IInjectedProps extends IChatMessageProps {
  chatStore: ChatStore;
}

@inject('chatStore')
@observer
class ChatMessage extends React.Component<IChatMessageProps> {
  protected get injected(): IInjectedProps {
    return this.props as IInjectedProps;
  }

  public render() {
    const message = this.props.item;
    const agentMessage = message.author.name !== 'You';
    const { agentConsumptionIndex } = this.injected.chatStore;

    if (message.status === 'chat-greeting') {
      return null;
    }

    if (agentMessage) {
      if (!message.text) {
        return null;
      }

      return (
        <Fragment>
          <AgentChatBubble className='k-bubble'>{message.text}</AgentChatBubble>
        </Fragment>
      );
    } else {
      return (
        <Fragment>
          <FlexContainer flexEnd>
            <CustomerChatBubble className='k-bubble'>{message.text}</CustomerChatBubble>
            {message.status === 'undelivered' && <ChatMessageWarningIcon />}
          </FlexContainer>
          {message.status === 'undelivered' && (
            <UndeliveredNotice>
              <p>Not Delivered</p>
              {message && message.retryCallback && <ResendStyled onClick={message.retryCallback}>RESEND</ResendStyled>}
            </UndeliveredNotice>
          )}
          <ReadReceipt>{`${message.index === agentConsumptionIndex ? 'Read' : ''}`}</ReadReceipt>
        </Fragment>
      );
    }
  }
}

export default ChatMessage;
